import { SceneKey } from './sceneKeys';

/** シーン遷移の定義 */
export interface SceneTransition {
  /** 遷移元シーン */
  from: SceneKey;
  /** 遷移先シーン */
  to: SceneKey;
}

/** 許可されたシーン遷移の一覧 */
export const SCENE_TRANSITIONS: SceneTransition[] = [
  { from: SceneKey.BOOT, to: SceneKey.TITLE },
  { from: SceneKey.TITLE, to: SceneKey.MODE_SELECT },
  { from: SceneKey.TITLE, to: SceneKey.CHARACTER_SELECT },
  { from: SceneKey.TITLE, to: SceneKey.SETTINGS },
  { from: SceneKey.TITLE, to: SceneKey.BATTLE_MODE_SELECT },
  // モード選択（キャンペーン・サバイバル・対戦・大会）
  { from: SceneKey.BATTLE_MODE_SELECT, to: SceneKey.CHARACTER_SELECT },
  { from: SceneKey.BATTLE_MODE_SELECT, to: SceneKey.VERSUS_SELECT },
  { from: SceneKey.BATTLE_MODE_SELECT, to: SceneKey.TITLE },
  { from: SceneKey.BATTLE_MODE_SELECT, to: SceneKey.TOURNAMENT_SETUP },
  // 対戦種別選択（対CPU・ローカル・観戦）
  { from: SceneKey.VERSUS_SELECT, to: SceneKey.CHARACTER_SELECT },
  { from: SceneKey.VERSUS_SELECT, to: SceneKey.MODE_SELECT },
  { from: SceneKey.VERSUS_SELECT, to: SceneKey.BATTLE_MODE_SELECT },
  { from: SceneKey.MODE_SELECT, to: SceneKey.CHARACTER_SELECT },
  { from: SceneKey.MODE_SELECT, to: SceneKey.BATTLE },
  { from: SceneKey.MODE_SELECT, to: SceneKey.TITLE },
  { from: SceneKey.CHARACTER_SELECT, to: SceneKey.BATTLE },
  { from: SceneKey.CHARACTER_SELECT, to: SceneKey.MODE_SELECT },
  { from: SceneKey.CHARACTER_SELECT, to: SceneKey.CHARACTER_SELECT },
  { from: SceneKey.CHARACTER_SELECT, to: SceneKey.DIFFICULTY_SELECT },
  { from: SceneKey.CHARACTER_SELECT, to: SceneKey.TITLE },
  { from: SceneKey.CHARACTER_SELECT, to: SceneKey.BATTLE_MODE_SELECT },
  { from: SceneKey.CHARACTER_SELECT, to: SceneKey.VERSUS_SELECT },
  { from: SceneKey.DIFFICULTY_SELECT, to: SceneKey.BATTLE },
  { from: SceneKey.DIFFICULTY_SELECT, to: SceneKey.CHARACTER_SELECT },
  { from: SceneKey.DIFFICULTY_SELECT, to: SceneKey.DIFFICULTY_SELECT },
  { from: SceneKey.BATTLE, to: SceneKey.RESULT },
  { from: SceneKey.BATTLE, to: SceneKey.BATTLE },
  { from: SceneKey.BATTLE, to: SceneKey.BATTLE_MODE_SELECT },
  { from: SceneKey.BATTLE, to: SceneKey.MODE_SELECT },
  { from: SceneKey.RESULT, to: SceneKey.TITLE },
  { from: SceneKey.RESULT, to: SceneKey.CHARACTER_SELECT },
  { from: SceneKey.RESULT, to: SceneKey.BATTLE },
  { from: SceneKey.RESULT, to: SceneKey.BATTLE_MODE_SELECT },
  { from: SceneKey.RESULT, to: SceneKey.VERSUS_SELECT },
  { from: SceneKey.SETTINGS, to: SceneKey.TITLE },
  { from: SceneKey.TITLE, to: SceneKey.BATTLE_STATS },
  { from: SceneKey.BATTLE_STATS, to: SceneKey.TITLE },
  // 開発用: スプライトテスト
  { from: SceneKey.BOOT, to: SceneKey.SPRITE_TEST },
  { from: SceneKey.SPRITE_TEST, to: SceneKey.TITLE },
  // サバイバルモード
  { from: SceneKey.TITLE, to: SceneKey.SURVIVAL_EXP_ALLOCATION },
  { from: SceneKey.BATTLE_MODE_SELECT, to: SceneKey.SURVIVAL_EXP_ALLOCATION },
  { from: SceneKey.BATTLE, to: SceneKey.SURVIVAL_EXP_ALLOCATION },
  { from: SceneKey.BATTLE, to: SceneKey.SURVIVAL_RESULT },
  { from: SceneKey.SURVIVAL_EXP_ALLOCATION, to: SceneKey.BATTLE },
  { from: SceneKey.SURVIVAL_EXP_ALLOCATION, to: SceneKey.TITLE },
  { from: SceneKey.SURVIVAL_RESULT, to: SceneKey.CHARACTER_SELECT },
  { from: SceneKey.SURVIVAL_RESULT, to: SceneKey.TITLE },
  // 大会モード
  { from: SceneKey.TOURNAMENT_SETUP, to: SceneKey.BATTLE_MODE_SELECT },
  { from: SceneKey.TOURNAMENT_SETUP, to: SceneKey.TOURNAMENT_BRACKET },
  { from: SceneKey.TOURNAMENT_BRACKET, to: SceneKey.BATTLE },
  { from: SceneKey.BATTLE, to: SceneKey.TOURNAMENT_BRACKET },
  { from: SceneKey.TOURNAMENT_BRACKET, to: SceneKey.TOURNAMENT_RESULT },
  { from: SceneKey.TOURNAMENT_RESULT, to: SceneKey.TITLE },
  { from: SceneKey.TOURNAMENT_RESULT, to: SceneKey.TOURNAMENT_SETUP },
  { from: SceneKey.TOURNAMENT_RESULT, to: SceneKey.BATTLE },
  // デバッグ画面
  { from: SceneKey.TITLE, to: SceneKey.DEBUG },
  { from: SceneKey.DEBUG, to: SceneKey.TITLE },
  { from: SceneKey.DEBUG, to: SceneKey.TOURNAMENT_RESULT },
  // AIキャラ作成・編集
  { from: SceneKey.TITLE, to: SceneKey.AI_CHARACTER_EDIT },
  { from: SceneKey.AI_CHARACTER_EDIT, to: SceneKey.TITLE },
  // 実績一覧
  { from: SceneKey.TITLE, to: SceneKey.ACHIEVEMENT },
  { from: SceneKey.ACHIEVEMENT, to: SceneKey.TITLE },
  // キャンペーン ステージ選択
  { from: SceneKey.BATTLE_MODE_SELECT, to: SceneKey.STAGE_SELECT },
  { from: SceneKey.STAGE_SELECT, to: SceneKey.CHARACTER_SELECT },
  { from: SceneKey.STAGE_SELECT, to: SceneKey.BATTLE_MODE_SELECT },
  { from: SceneKey.RESULT, to: SceneKey.STAGE_SELECT },
  { from: SceneKey.CHARACTER_SELECT, to: SceneKey.STAGE_SELECT },
];

/**
 * 指定シーンから遷移可能な先のシーンキー一覧を返す
 */
export function getAvailableTransitions(from: SceneKey): SceneKey[] {
  return SCENE_TRANSITIONS.filter((t) => t.from === from).map((t) => t.to);
}

/**
 * 指定の遷移が許可されているか確認する
 */
export function isValidTransition(from: SceneKey, to: SceneKey): boolean {
  return SCENE_TRANSITIONS.some((t) => t.from === from && t.to === to);
}
